<template>
  <div class="home-forum flex-col section">
    <homeTitleVue txt="INTERNATIONAL FORUM ON ENGINEERING" />
    <ul class="flex-row justify-between home-forum-list">
      <li v-for="item in data" :key="item.link">
        <HomeForumBlockVue :data="item" />
      </li>
    </ul>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import homeTitleVue from "./home-title.vue";
import HomeForumBlockVue from "./HomeForumBlock.vue";
export default defineComponent({
  name: "HomeForum",
  components: { homeTitleVue, HomeForumBlockVue },
  setup() {
    return {
      data: [
        {
          id: 4,
          link: "https://thu-ifee.tsinghua.edu.cn/zh/2024n/index.html",
          title: "2024",
        },
        {
          id: 3,
          link: "http://thu-ifee.tsinghua.edu.cn/zh/2022n/index.html",
          title: "the 3rd international forum on engineering education",
        },
        {
          id: 1,
          link: "http://thu-ifee.tsinghua.edu.cn/zh/index.html",
          title:
            "the 2nd international forum on engineering education environment and sustainable development",
        },
        {
          id: 2,
          link: "http://thu-ifee.tsinghua.edu.cn/zh/wqhg/index.html",
          title: "Innovations in Engineering Education",
        }
      ],
    };
  },
});
</script>
<style lang="scss" scoped>
.home-forum {
  .home-forum-list {
    padding: 0;
    margin-top: 30px;
    flex-wrap: wrap;
  }
}
</style>
